<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent" v-on:click="showPrizeMore = null">
        <h4>Video</h4>
        <div class="formCnt">
          <div class="fieldGroup">
            <div class="videoPreview" v-if="d.media.type === 'video'">
              <div class="videoProcessing" v-if="d.media.status === 'processing'">
                <div class="progressCnt" v-on:click.stop="doNothing">
                  <div class="progress processing"
                    v-bind:style="{width: `${d.media.progress}%`}">
                    <span>Processing {{d.media.progress}}%</span>
                    <div class="bg"></div>
                  </div>
                </div>
              </div>
              <div class="theVideo" v-else v-on:click.stop="doNothing">
                <VuePlyr ref="video" :options="{ hideControls: false }">
                  <video></video>
                </VuePlyr>
              </div>
            </div>
          </div>
          <form v-on:submit.prevent="handleSubmit">
            <div class="fieldGroup">
              <div class="fieldCnt" :class="{hasError: form.name.error}">
                <label>Gallery Title</label>
                <input type="text" class="field" placeholder="Title..."
                  v-model="form.name.model" v-on:input="fieldChanged('name')">
                <div class="fieldError">Please input gallery title</div>
              </div>
            </div>
            <div class="fieldGroup">
              <label>Description</label>
              <textarea placeholder="Description..."
                class="field" rows="2" v-model="form.description.model"/>
            </div>
          </form>
        </div>
        <div class="modalAction">
          <button class="btn btnSecondary" type="button"
            v-on:click="close(false)" v-if="!btnLoading">
            <span>Cancel</span>
          </button>
          <button class="btn btnPrimary" type="submit" v-on:click="handleSubmit"
            :class="{disabled: d.media.length < 1,
            btnLoading: btnLoading}">
            <span>Save Video</span>
          </button>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
      <MediaSelector ref="mediaSelector"/>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

import Confirmation from '@/components/Confirmation.vue';
import MediaSelector from '@/components/MediaSelector.vue';
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'addUndian',
  components: {
    Confirmation,
    MediaSelector,
    Snackbar,
    VuePlyr,
  },
  data() {
    return {
      show: false,
      loading: false,
      next: null,
      btnLoading: false,
      parentId: null,
      d: null,
      prizeIdx: 0,
      showPrizeMore: false,

      /**
       * Form
       *
       */
      form: {
        name: { model: '', error: null },
        description: { model: '', error: null },
      },
    };
  },
  methods: {
    open(parentId, d, n) {
      this.d = d;
      this.parentId = parentId;
      this.form.name.model = (d.title) ? d.title : '';
      this.form.name.error = null;
      this.form.description.model = (d.description) ? d.description : '';
      this.btnLoading = false;
      this.next = n;
      this.show = true;
      if (d.media) {
        const src = [];
        const m = d.media;
        if (m.status === 'processing') {
          this.$http.get(this.$config.uri(`media/detail/${m.id}`)).then((r) => {
            if (r.data.status !== 200) return;
            this.media = r.data.data;
            if (this.media.status === 'processing');
            this.timer = setTimeout(() => {
              this.getData(r.data.data);
            }, 3000);
          });
        } else if (m.type === 'video') {
          if (m.vid1080p) src.push({ src: m.vid1080p, type: 'video/mp4', size: 1080 });
          if (m.vid720p) src.push({ src: m.vid720p, type: 'video/mp4', size: 720 });
          if (m.vid480p) src.push({ src: m.vid480p, type: 'video/mp4', size: 480 });
          if (m.vid360p) src.push({ src: m.vid360p, type: 'video/mp4', size: 360 });
          setTimeout(() => {
            const v = this.$refs.video.player;
            v.source = { type: 'video', title: m.name, sources: src };
            // v.play();
          });
        } else if (m.type === 'audio') {
          src.push({ src: m.audio, type: m.mimetype });
          setTimeout(() => {
            const v = this.$refs.audio.player;
            v.source = { type: 'audio', title: m.name, sources: src };
            // v.play();
          });
        }
      }
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    deletePrize(i, item) {
      this.showPrizeMore = null;
      this.$refs.confirmDialog.open({
        title: 'Delete Image',
        desc: 'Are you sure you want to delete this image from gallery?',
      }, (b) => {
        if (!b) return;
        this.d.media.splice(i, 1);
      });
    },
    editPrize(i, item) {
      this.showPrizeMore = null;
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        this.d.media[i].id = media.id;
        this.d.media[i].imageBl = media.imageBl;
        this.d.media[i].imageTh = media.imageTh;
        this.d.media[i].imageSm = media.imageSm;
        this.d.media[i].imageMd = media.imageMd;
        this.d.media[i].imageLg = media.imageLg;
      });
    },
    addPrize() {
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        this.d.media.push(media);
      });
    },
    handleSubmit() {
      if (this.d.media.length < 1) return;
      const formData = {
        title: this.form.name.model,
        status: 'published',
        description: this.form.description.model,
        parentId: this.parentId,
        media: this.d.media,
        type: 'video',
      };
      if (this.d && this.d.id) formData.id = this.d.id;
      if (!formData.title) {
        this.form.name.error = true;
        return;
      }
      this.btnLoading = true;
      this.$http.post(this.$config.uri('article/save'), formData).then((r) => {
        this.btnLoading = false;
        if (r.data.status !== 200) {
          this.form.code.error = r.data.message;
          return;
        }
        this.close(true);
      });
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
  },
};
</script>

<style scoped lang="scss">
.tabCnt{
  margin: -16px 0 16px;
  .tab{
    width: 50%;
    background-color: #fff;
    padding: 10px 0;
    padding-left: 26px;
    &:before{
      left: 0; top: 13px;
      background-image: url(../assets/upload-black.png);
    }
    &.old{
      &:before{
        background-image: url(../assets/history.png);
      }
    }
  }
}
.fieldGroup.fg3{
  display: flex;
  .fieldCnt{
    width: 37%;
    margin-right: auto;
    &.radio{
      width: 120px;
      margin-right: 0;
    }
    .field.readonly{
      background-color: #eee;
      border-color: #ccc;
      cursor: default;
      box-shadow: none;
      outline: none;
    }
    .radioCnt{
      padding-top: 30px;
      .radioItem{
        position: relative;
        padding: 3px 0 0 60px;
        cursor: pointer;
        font-size: 18px;
        color: #767676;
        font-weight: 600;
        .radioIn{
          position: absolute;
          left: 0; top: 0;
          width: 50px; height: 30px;
          background-color: #ccc;
          border-radius: 50px;
          transition: all .2s ease;
          .radioHandle{
            background-color: #fff;
            position: absolute;
            left: 4px; top: 4px;
            transition: all .2s ease;
            width: 22px; height: 22px;
            border-radius: 50%;
          }
        }
        &.on{
          .radioIn{
            background-color: #0067ff;
            .radioHandle{
              left: 23px;
            }
          }
        }
      }
    }
  }
}
.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  .modalOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,.7);
    // backdrop-filter: saturate(180%) blur(20px);
    z-index: 1;
    opacity: 1;
  }
  .modalContent{
    position: absolute;
    background-color: #fff;
    z-index: 2;
    padding: 30px 80px;
    border-radius: 5px;
    margin-top: -20px;
    overflow: hidden;
    max-width: none;
    width: 600px;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .parent{
      box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      border-radius: 5px;
      padding: 10px 16px;
      margin-bottom: 24px;
      h4{
        font-size: 14px;
        text-transform: uppercase;
        margin: 0;
        font-weight: 600;
        color: #999;
      }
      h5{
        margin: 0;
        margin-top: -2px;
        text-align: left;
        font-size: 20px;
        color: #555;
      }
    }
    .searchPeserta{
      margin: -16px 0 0;
      border-bottom: #eee 1px solid;
      padding: 10px 0;
      position: relative;
      &:before{
        position: absolute;
        z-index: 3;
        content: "";
        right: 16px; top: 20px;
        width: 16px; height: 16px;
        background-image: url(../assets/search.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .5;
      }
      &.searching{
        &:before{
          background-image: url(../assets/loading-2.svg);
        }
      }
      .field{
        border-radius: 50px;
        padding: 8px 16px;
      }
    }
    .pesertaCnt{
      height: 480px;
      overflow-y: auto;
      margin: 0 0 -30px;
      padding: 10px 0 20px;
      box-sizing: border-box;
      &.loadingPeserta{
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 46px auto;
      }
      .pesertaItem{
        padding: 6px 0;
        padding-right: 60px;;
        position: relative;
        &.loadMore{
          color: #0e5dd2;
          padding: 10px 0;
          cursor: pointer;
          display: inline-block;
          padding-left: 24px;
          &:before{
            position: absolute;
            content: "";
            left: 0; top: 12px;
            width: 16px; height: 16px;
            background-image: url(../assets/down-arrow-blue.png);
            background-position: center;
            background-size: 16px auto;
            background-repeat: no-repeat;
          }
          &.loadingMore{
            &:before{
              background-image: url(../assets/loading.svg);
            }
          }
        }
        .delete{
          position: absolute;
          right: 10px; top: 50%;
          transform: translateY(-50%);
          color: #0e5dd2;
          font-size: 15px;
          cursor: pointer;
          &:hover{
            color: #0747a6;
          }
        }
        h4{
          margin: 0 0 2px;
          font-size: 18px;
        }
        p{
          margin: 0;
          .bull{
            margin: 0 10px;
          }
        }
      }
    }
    .formCnt{
      .videoPreview{
        width: 100%;
        .theVideo{
          border-radius: 5px;
          overflow: hidden;
        }
        &.youtube{
          text-align: center;
          iframe{
            width: 100%; height: 540px;
            max-width: 960px;
          }
        }
      }
    }
    h4{
      margin: 0;
      font-size: 24px;
      font-weight: normal;
      margin-bottom: 20px;
      color: #444;
      text-align: left;
    }
    p{
      margin: 0;
      color: #767676;
    }
    .modalAction{
      margin: 30px -80px -30px;
      padding: 12px 30px;
      text-align: right;
      // background-color: #eee;
      border-top: #eee 1px solid;
      position: relative;
      .btn{
        margin-left: 10px;
      }
    }
  }
}

.imported{
  position: absolute;
  bottom: 0; right: 0; left: 0; top: 0;
  z-index: 991;
  text-align: center;
  background-color: #f5f5f5;
  padding: 40px 60px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  .importedIn{
    width: 100%;
    max-width: 460px;
    img{
      height: 86px;
      margin: 0 0 10px;
    }
  }
  h6{
    margin: 0 0 4px;
    font-size: 24px;
    font-weight: normal;
    text-align: center;
  }
  p{
    line-height: 1.4;
  }
  .btn{
    margin: 16px 0 -20px !important;
    &.btnPrimary{
      margin-left: 10px !important;
    }
  }
}
.errorLabel{
  color: red;
  font-size: 13px;
  margin: 5px 0 0 5px;
}
.dragArea{
  padding: 40px 0;
  text-align: center;
  border: #ccc 4px dashed;
  position: relative;
  &.hasError{
    border-color: red;
  }
  .uploadPorgress{
    position: absolute;
    left: -4px; top: -4px; right: -4px; bottom: -4px;
    z-index: 1;
    border-radius: 5px;
    background-color: #eee;
    display: flex;
    justify-content: center;
    align-items: center;
    display: none;
    .progressLabel{
      font-size: 15px;
      color: #767676;
    }
    .progressBar{
      background-color: #ddd;
      height: 12px;
      width: 200px;
      margin-top: 10px;
      border-radius: 50px;
      .pbin{
        height: 100%;
        background-color: #ed1d51;
        background-image: linear-gradient(45deg, #ed1d51, #ffc875);
        border-radius: 50px;
        transition: width .3s linear;
      }
    }
  }
  &.uploading{
    border-color: #fff;
    .uploadPorgress{
      display: flex;
    }
  }
  &.dragover{
    border-color: #0057d8;
  }
  p{
    margin: 0;
    font-size: 17px;
    color: #444;
  }
  span{
    display: block;
    color: #767676;
    margin: 4px 0 6px;
  }
  button{
    border-radius: 3px;
    color: #fff;
    border: none;
    box-shadow: none;
    font-size: 16px;
    background-color: #0057d8;
    padding: 8px 16px;
    outline: 0;
    cursor: pointer;
    &:hover{
      background-color: #0067ff;
    }
  }
}

.help{
  margin-top: 20px;
  color: #767676;
  font-size: 15px;
  a{
    display: inline-block;
    padding: 5px 14px;
    margin: 6px 0 10px;
    border-radius: 50px;
    font-size: 15px;
    border: #ddd 1px solid;
    padding-left: 36px;
    position: relative;
    color: #444;
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    &:before{
      content: "";
      position: absolute;
      left: 14px; top: 0; bottom: 0;
      width: 14px;
      background-image: url(../assets/download-o.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  img{
    width: 100%;
    height: auto;
    border: #eee 1px solid;
    box-sizing: border-box;
  }
}

</style>
